import { get } from 'lodash';

const apiConfig = window.apiConfig;
export const addToParty = (request) => {

    return fetch(`https://secretsantabe.reinhardtvanwyk.com/registration/addtoparty`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        body: JSON.stringify(request),
    }).then((data) => {
        return data;
    })

}

export const handleAddingToParty = (action) => {
    const updatedPayload = {
        ...action,
        Gifts: action.Gifts || [],
        PartyId: 1
    }
    return addToParty(updatedPayload).then(r => r);
}

export const updateGifts = (registerUserReq) => {
    return fetch(`https://secretsantabe.reinhardtvanwyk.com/party/updateUser`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        body: JSON.stringify(registerUserReq),
    }).then(r => r.json()).then(r => {
        console.log(r);
        return r;
    })
}